"use strict";
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chat_ChatState = exports.protobufPackage = void 0;
exports.protobufPackage = "";
var Chat_ChatState;
(function (Chat_ChatState) {
    Chat_ChatState["CHAT_STATE_UNSPECIFIED"] = "CHAT_STATE_UNSPECIFIED";
    Chat_ChatState["CHAT_STATE_OPEN"] = "CHAT_STATE_OPEN";
    Chat_ChatState["CHAT_STATE_CLOSE"] = "CHAT_STATE_CLOSE";
})(Chat_ChatState || (exports.Chat_ChatState = Chat_ChatState = {}));
